import {
  FeatureProtocolInstance,
  FeatureProtocolInstanceValue,
  LINKS,
} from "@silo/types";

const siloObserverSubPath: FeatureProtocolInstanceValue<"analytics", string> = {
  mainnetLegacy: "ethereum-original",
  arbitrum: "arbitrum-original",
  mainnetLlama: "ethereum-llama",
  optimism: "optimism-original",
};

type AnalyticsProtocolKey = FeatureProtocolInstance<"analytics">;

export function getAnalyticsMarketLink(
  rawSymbol: string,
  protocolKey: AnalyticsProtocolKey
): string {
  return `${LINKS.SILO_OBSERVER}silo/${siloObserverSubPath[protocolKey]}/${rawSymbol}/tvl`;
}
